// a utility function to get the class with highest score in the given array of
// event details.
export const getHighestEventClass = (eventDetails) => {
  let maxInd = 0;
  eventDetails.forEach((obj, idx) => {
    if (obj.predictionScore > eventDetails[maxInd].predictionScore) {
      maxInd = idx;
    }
  });
  return eventDetails[maxInd];
};
